import { createContext, useMemo } from 'react';
import { Router, useHistory as useReactRouterHistory } from 'react-router-dom';
import { ReadOnlyURLSearchParams } from './ReadOnlyURLSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchParamsContext = /*#__PURE__*/createContext(null);
export const PathnameContext = /*#__PURE__*/createContext(null);
export const HistoryContext = /*#__PURE__*/createContext(null);

/**
 * RouterProvider component to provide routing context to the application.
 */
export function RouterProvider({
  children,
  history
}) {
  return /*#__PURE__*/_jsx(Router, {
    history: history,
    children: /*#__PURE__*/_jsx(RouterProviderInternal, {
      children: children
    })
  });
}

/**
 * RouterProviderInternal component to provide Quartz-specific routing context.
 * This has to be a separate component so it can use the `useReactRouterHistory` hook
 */
function RouterProviderInternal({
  children
}) {
  // The `useHistory()` from our react-router-dom@5.0.1 repackage re-renders for every location change
  // See https://github.com/remix-run/react-router/releases/tag/v5.2.0
  const history = useReactRouterHistory();
  const searchParams = useMemo(() => {
    return new ReadOnlyURLSearchParams(history.location.search);
  }, [history.location.search]);
  return /*#__PURE__*/_jsx(HistoryContext.Provider, {
    value: history,
    children: /*#__PURE__*/_jsx(SearchParamsContext.Provider, {
      value: searchParams,
      children: /*#__PURE__*/_jsx(PathnameContext.Provider, {
        value: history.location.pathname,
        children: children
      })
    })
  });
}